import { render, staticRenderFns } from "./SearchableFeatArtistList.vue?vue&type=template&id=60dd9ef8&scoped=true&"
import script from "./SearchableFeatArtistList.vue?vue&type=script&lang=js&"
export * from "./SearchableFeatArtistList.vue?vue&type=script&lang=js&"
import style0 from "./SearchableFeatArtistList.vue?vue&type=style&index=0&id=60dd9ef8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dd9ef8",
  null
  
)

export default component.exports